<template>
	<v-container grid-list-xl>	
		<v-form v-model="isAddValid">
			<v-layout row>
				<v-flex lg12>
					<label class="blackLabel">* Pricelist Name:</label>			
					<v-text-field label="Name" v-model="pricelistName" :rules="nameRules" required solo single-line></v-text-field>
				</v-flex>				
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncClonePlist()">Clone</v-btn>
					</div>	
				</div>							
			</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'Settings',
	  data () {
			return {
				search: '',
				isAddValid: false,
				pricelistName: '',
				nameRules: [
					v => !!v || 'Pricelist name is required',				
				]				
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},			
			fncClonePlist() {				
				this.$store.dispatch({
					type: 'fncClonePlist',	
					pricelistName: this.pricelistName,
					pricelistId: this.globalModalParams.pl_id
				})
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd'
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>